import React from "react";
import {
  Button,
  Label,
} from "reactstrap";
import SelectInput, { components } from 'react-select';
import TimeFormatter from '../../../commons/TimeFormatter';
import Services from "./Services";
import Utility from "../../Torzsadatok/Idopontfoglalo/Utility";
import { DatePicker } from "../../../commons/controls";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import RFForm from "../../../components/Form/RFForm";
import RFField from "../../../components/Form/RFField";
import CustomTooltip from "../../../components/Tooltip/CustomTooltip";
import getTooltip from "./IdopontPublicTooltips";
import SelectField from "../../../components/Form/SelectField";
import ProgressButton from "../../../commons/ProgressButton"

export default class IdopontPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blockButtons: [],
      captchaToken: null,
      customDolgozo: false,
      date: null,
      dolgozoOptions: [],
      dolgozoSelected: null,
      helyszinJSON: [],
      helyszinObj: null,
      helyszinOptions: [],
      idoSelected: null,
      loading: false,
      napSelected: null,
      naptarBlockBeans: [],
      naptarJSON: {},
      naptarOptions: null,
      obj: {},
      orszagOptions: [],
      telefonTipusOptions: [],
      szolgaltatasJSON: [],
      szolgaltatasLeiras: null,
      szolgaltatasOptions: [],
      szolgaltatasSelected: null,
      szuletesnap: null,
      time: null,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: "HIDD",

      sendButtonLoading: false,
    };

    this.captchaRef = React.createRef();

  }

  componentDidMount() {
    this.updateHelyszinFilter();
    this.getTelefonEnum();
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  updateHelyszinFilter = () => {
    Services.listHelyszin((err, res) => {
      if (!err) {
        let helyszinOptions = [];
        for (let helyszin of res[0]) {
          let option = <option value={helyszin.id}>{helyszin.nev}</option>;
          Utility.insertByOrder(helyszinOptions, option);
        }
        this.setState({ helyszinOptions, helyszinJSON: res[0] });
        if (helyszinOptions.length > 0)
          this.setSzin(res[0][0]);
        if (helyszinOptions.length === 1)
          this.handleHelyszinChange(this, helyszinOptions[0].props.value);
      }
    });
  };

  setSzin = (helyszin) => {
    let szinAdatok = helyszin?.szinAdatok;
    if (szinAdatok) {
      if(szinAdatok.color[0] === 'VILAGOS') {
        document.querySelector('body').classList.remove('dark-theme');
        document.body.style.setProperty("--svg-viewer-hatter-szin", "#fff");
        document.body.style.setProperty("--elsodleges-szin", "#" + szinAdatok.color[1]);
        document.body.style.setProperty("--footer-hatter", "#" + szinAdatok.color[4]);
        document.body.style.setProperty("--input-border-focus-szin", "#" + szinAdatok.color[2])
        document.body.style.setProperty("--form-control-focus-szin", "rgba("+this.hexToRgb(szinAdatok.color[2]).r +
          "," + this.hexToRgb(szinAdatok.color[2]).g+"," + this.hexToRgb(szinAdatok.color[2]).b + ",0.8)");
        document.body.style.setProperty("--navbar-background", "rgba("+this.hexToRgb(szinAdatok.color[3]).r +
          ","+this.hexToRgb(szinAdatok.color[3]).g+"," + this.hexToRgb(szinAdatok.color[3]).b + ",0.8)");
        } else {
        document.querySelector('body').classList.add('dark-theme');
        document.body.style.setProperty("--elsodleges-szin", "#" + szinAdatok.color[1]);
        document.body.style.setProperty("--footer-hatter", "#" + szinAdatok.color[4]);
        document.body.style.setProperty("--input-border-focus-szin", "#" + szinAdatok.color[2])
        document.body.style.setProperty("--form-control-focus-szin", "rgba("+this.hexToRgb(szinAdatok.color[2]).r +
          ","+this.hexToRgb(szinAdatok.color[2]).g+"," + this.hexToRgb(szinAdatok.color[2]).b + ",0.8)");
        document.body.style.setProperty("--navbar-background", "rgba("+this.hexToRgb(szinAdatok.color[3]).r +
          ","+this.hexToRgb(szinAdatok.color[3]).g+"," + this.hexToRgb(szinAdatok.color[3]).b + ",0.8)");
      }
      if (!szinAdatok.logo[0]) {
        document.getElementById("headerLogo").style.setProperty("display", "none");
        document.getElementById("szlogen").style.setProperty("position", "inherit")
      } else {
        const base64Logo = "data:image/png;base64," + szinAdatok.logo[0];
        document.getElementById("headerLogo").src = base64Logo;
      }
      // TODO átírni/aktualizálni
      document.getElementById("navbar-brand").href = "www.zalaszam.hu";
    }
  }

  updateSzolgaltatasFilter = helyszinid => {
    Services.listSzolgaltatasByHelyszin(helyszinid, (err, res) => {
      if (!err) {
        let szolgaltatasOptions = res[0];
        this.setState({ szolgaltatasOptions, szolgaltatasJSON: res[0] });
        if (szolgaltatasOptions.length === 1)
          this.handleSzolgaltatasChange(this, szolgaltatasOptions[0].props.value);
      }
    });
  };

  renderNaptarBlocks = () => {
    const { naptarBlockBeans } = this.state;
    let blockButtons = [];
    let i = 1;
    for (const block of naptarBlockBeans) {
      let date = new Date(block.kezdet);
      let button = (
        <div
          className="col-2"
          style={{ paddingLeft: 3, paddingRight: 3 }}
        >
          <Button
            value={block.kezdet}
            onClick={() => { this.setState({ idoSelected: block.kezdet }); }}
            active={this.state.idoSelected == block.kezdet}
            className="col-12"
            style={{ textAlign: 'center', paddingLeft: 0, paddingRight: 0 }}
          >
            {date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
          </Button>
        </div>
      );
      blockButtons.push(button);
      if (i % 5 == 0)
        blockButtons.push(<div className="w-100 d-none d-md-block d-lg-none" />);
      i++
    }
    return blockButtons;
  }

  getDolgozoOptions = (dolgozobeans) => {
    let dolgozoOptions = [];
    for (const dolgozo of dolgozobeans) {
      let option = <option value={dolgozo.id}>{dolgozo.nev}</option>;
      Utility.insertByOrder(dolgozoOptions, option);
    }
    this.setState({ dolgozoOptions });
  }

  getTelefonEnum = () => {
    Services.listTelefonEnum((err, res) => {
      if (!err) {
        let options = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);

        this.setState({
          orszagOptions: res[0][0],
          telefonTipusOptions: options,
        });
      }
    });
  }

  setOrszaghivo = (value) => {
    if (value && value.action === 'clear') {
      this.setState({ orszaghivo: null });
      return;
    }

    this.state.orszagOptions.forEach((item) => {
      if (item.name === value) {
        this.setState({ orszaghivo: item.name.toUpperCase() });
      }
    });
  }


  setTelefonTipus = (value) => {
    this.setState({ telefontipus: value });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({ [name]: value });
  }

  handleDolgozoChange = (event, value) => {
    const { helyszinObj, idoSelected, napSelected, szolgaltatasSelected } = this.state;
    value = this.emptyOrNull(value);
    let date = new Date(napSelected);
    date.setHours(0);
    date.setMinutes(0);
    Services.initFoglalas(date, helyszinObj.id, szolgaltatasSelected.id, value, false, true, (err, res) => {
      if (!err) {
        this.setState({ naptarBlockBeans: res[0].naptarblockbeans });
        if (!res[0].naptarblockbeans.some(element => element.kezdet == idoSelected))
          this.setState({ idoSelected: null });
      }
    });
    this.setState({ dolgozoSelected: value });
  }

  handleTimeChange = (event, value) => {
    const { customDolgozo, dolgozoSelected, helyszinObj, szolgaltatasSelected } = this.state;
    if (customDolgozo) {
      Services.initFoglalas(value || this.state.date, helyszinObj.id, szolgaltatasSelected.id, dolgozoSelected, true, false, (err, res) => {
        if (!err) {
          this.getDolgozoOptions(res[0].dolgozobeans);
          if (!res[0].dolgozobeans.some(element => element.id == dolgozoSelected)) {
            this.setState({ dolgozoSelected: null });
          }
        }
      });
      this.setState({ time: value });
    }
  }

  handleHelyszinChange = (event, value) => {
    const helyszinObj = this.state.helyszinJSON.find(obj => obj.id == value);
    this.setState({ helyszinObj, szolgaltatasSelected: null, idoSelected: null });
    this.updateSzolgaltatasFilter(value);
  };

  handleSzolgaltatasChange = (value) => {
    const szolgaltatas = this.state.szolgaltatasJSON.find(
      element => element.id == value.id
    );
    this.setState({ napSelected: "" });
    Services.customDolgozo(value.id, (err, res) => {
      if (!err) {
        this.setState({ customDolgozo: res[0] });
      }
    });
    this.setState({
      szolgaltatasSelected: value,
      szolgaltatasLeiras: szolgaltatas ? szolgaltatas.leiras : "",
      napSelected: '',
      blockButtons: []
    }, () => {
      this.updateNaptar();
    });
  };

  updateNaptar = () => {
    const { helyszinObj, szolgaltatasSelected } = this.state;
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long'
    };
    Services.listNaptarDays(helyszinObj.id, szolgaltatasSelected.id, (err, res) => {
      if (!err) {
        let naptarOptions = [];
        for (const instant of res[0]) {
          let date = new Date(instant);
          naptarOptions.push(
            <option value={instant}>
              {Intl.DateTimeFormat('hu', options).format(date)}
            </option>
          );
        }
        this.setState({ naptarOptions });
      }
    });
  }

  handleNapChange = (e, value) => {
    if (!value)
      return;
    const { customDolgozo, helyszinObj, szolgaltatasSelected } = this.state;
    let date = new Date(value);
    date.setHours(0);
    Services.initFoglalas(date, helyszinObj.id, szolgaltatasSelected.id, null, customDolgozo, true, (err, res) => {
      if (!err) {
        this.setState({ naptarBlockBeans: res[0].naptarblockbeans, napSelected: value, idoSelected: null, dolgozoSelected: '' });
        if (res[0].naptarblockbeans?.length == 1)
          this.setState({ idoSelected: res[0].naptarblockbeans[0].kezdet })
        if (customDolgozo)
          this.getDolgozoOptions(res[0].dolgozobeans);
      }
    }
    );
  }

  handleVerificationSuccess = (token) => {
    this.setState({ captchaToken: token });
  }

  addFoglalas = (e, objModal) => {
    if (!objModal.hozzajarulas) {
      this.props.globals.addError('Időpont foglalásához az adatvédelmi nyilatkozat elfogadása kötelező!');
      return;
    }

    const {
      captchaToken,
      helyszinObj,
      idoSelected,
      telefontipus,
      orszaghivo,
      szolgaltatasSelected,
      szuletesnap,
    } = this.state;
    let insertObj = {
      kezdet: new Date(idoSelected),
      szolgaltatasid: szolgaltatasSelected.id,
      helyszinid: helyszinObj.id,
      captchatoken: captchaToken,
      partner: {
        titulus: objModal.titulus,
        vezeteknev: objModal.vezeteknev,
        keresztnev: objModal.keresztnev,
        email: objModal.email,
        szuletesnap: szuletesnap ? TimeFormatter.formatDate(new Date(szuletesnap)) : null,
        telefontipus: telefontipus,
        orszaghivo: orszaghivo,
        telefon: objModal.tel,
      },
      dolgozo: {
        id: objModal.dolgozoid
      }
    };
    this.setState({ sendButtonLoading: true });
    Services.addFoglalas(insertObj, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás beküldve!');
        this.setState({ dolgozoSelected: '', idoSelected: null });
      } else {
        this.captchaRef.current.resetCaptcha();
      }
      this.setState({ sendButtonLoading: false });
    });
  };

  renderValasztok = () => {
    const {
      helyszinObj,
      helyszinOptions,
      szolgaltatasLeiras,
      szolgaltatasOptions,
      szolgaltatasSelected,
    } = this.state;
    return (
      <div>
        <RFForm>
          <h2>Szolgáltatás</h2>
          <div className="row pl-1">
            <div className="col-md-6 col-xl-5">
              <RFField
                type="select"
                name="helyszinselect"
                label="Helyszín: *"
                value={helyszinObj && helyszinObj.id}
                onChange={this.handleHelyszinChange}
                defaultSelect={<option value="" disabled>Válassz helyszínt...</option>}
                selectOptions={helyszinOptions}
              />
            </div>
            <div className="col-md-6 col-xl-5">
              <SelectField
                name="szolgaltatasselect"
                id="szolgaltatasselect"
                label="Szolgáltatás: *"
                placeholder="Válassz szolgáltatást..."
                noOptionsMessage={() => "Nincs ilyen szolgáltatás"}
                searchPromptText="Válassz szolgáltatást..."
                loadingMessage={() => "Keresés..."}
                classNames={{
                  control: () => "select-input",
                  menu: () => "select-input",
                  singleValue: () => "select-input",
                  placeholder: () => "select-input",
                }}
                value={szolgaltatasSelected}
                onChange={this.handleSzolgaltatasChange}
                disabled={!helyszinObj}
                options={szolgaltatasOptions}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nev}
              />
            </div>
          </div>
          {szolgaltatasSelected &&
            <div className="col-12">
            <Label>Szolgáltatás leírás:</Label>
              <textarea
                rows="2"
                name="leiras"
                value={szolgaltatasLeiras}
                style={{ minHeight: 50 }}
                readonly
                disabled
              />
            </div>
          }
        </RFForm>
      </div>
    );
  };

  renderIdopont = () => {
    const {
      customDolgozo,
      dolgozoOptions,
      dolgozoSelected,
      napSelected,
      naptarBlockBeans,
      naptarOptions,
      szolgaltatasSelected,
    } = this.state;
    if (!szolgaltatasSelected)
      return;

    return <div>
      <h2>Időpont</h2>
      <RFForm>
        <div className="row">
          <div className="col-12 col-md-4 col-xl-3">
            <RFField
              type="select"
              name="napselect"
              label='Foglalható időpontok: *'
              value={napSelected}
              onChange={this.handleNapChange}
              disabled={!naptarOptions}
              defaultSelect={<option value="" disabled>Válassz dátumot...</option>}
              selectOptions={naptarOptions}
            />
            {napSelected &&
              <div className="col-12 d-none d-md-block pl-0 pr-0">
                  {customDolgozo && naptarBlockBeans.length != 0 &&
                    <RFField
                      label="Szolgáltató személy:"
                      name="dolgozoid"
                      type="select"
                      onChange={this.handleDolgozoChange}
                      value={dolgozoSelected}
                      defaultValue={Utility.returnFirstValueIfSingleElementArray(dolgozoOptions)}
                      defaultSelect={<option value=''>Válassz szolgáltató személyt...</option>}
                      selectOptions={dolgozoOptions}
                    />
                  }
              </div>
            }
          </div>
          {napSelected &&
            <div className="col-12 col-md">
              <div className="col-12 row no-gutters">
                {this.renderNaptarBlocks()}
              </div>
              <div className="col-md-6 col-xl-5 d-md-none">
                {customDolgozo && naptarBlockBeans.length != 0 &&
                  <RFField
                    label="Szolgáltató személy:"
                    name="dolgozoid"
                    type="select"
                    onChange={this.handleDolgozoChange}
                    value={dolgozoSelected}
                    defaultValue={Utility.returnFirstValueIfSingleElementArray(dolgozoOptions)}
                    defaultSelect={<option value=''>Válassz szolgáltató személyt...</option>}
                    selectOptions={dolgozoOptions}
                  />
                }
              </div>
            </div>
          }
        </div>
      </RFForm>
    </div>
  }

  renderSzemelyes = () => {
    const {
      helyszinObj,
      idoSelected,
      napSelected,
      telefonTipusOptions,
      orszagOptions,
    } = this.state;
    if (!idoSelected || !napSelected)
      return;

    const Option = ({ children, ...props }) => {
        const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
        const newProps = Object.assign(props, { innerProps: rest });
        return (
          <components.Option
            {...newProps}
          >
            <div className="flag-format" onClick={() => this.setOrszaghivo(props.data.name)}>
              <span
                className={'flag-icon flag-icon-' + props.data.name.toLowerCase()}
              />
              <b style={{ paddingLeft: ' 5px'}}>{props.data.caption}</b>
              {' '}
              +
              {props.data.num}
            </div>
          </components.Option>
        );
      };

    return <div>
      <h2>Személyes adatok</h2>
      <RFForm onSubmit={this.addFoglalas}>
        <div className="row">
          <div className="col-12 col-sm-2">
            <RFField
              label="Titulus: "
              name="titulus"
            />
          </div>
          <div className="col-12 col-sm-5">
            <RFField
              label="Vezetéknév: *"
              name="vezeteknev"
              required
            />
          </div>
          <div className="col-12 col-sm-5">
            <RFField
              label="Keresztnév: *"
              name="keresztnev"
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-2">
            <RFField
              label="E-mail cím: *"
              name="email"
              required
            />
          </div>
          <div className="col-12 col-sm-1">
            <DatePicker
              label="Születési dátum:"
              id='szuletesnap'
              name='szuletesnap'
              onChange={v => this.handleSelectInputChange(v, 'szuletesnap')}
              max={new Date()}
            />
          </div>
          <div className="col-12 col-sm-3">
            <RFField
              type="select"
              name="telefontipus"
              id="telefontipus"
              label="Telefon típus:"
              onChange={(e, v) => this.setTelefonTipus(v)}
              errorMessage="Kötelező mező!"
              defaultSelect={<option key="null" value={''}>Válassz opciót...</option>}
              selectOptions={telefonTipusOptions}
            />
          </div>
          <div className="col-12 col-sm-3">
            <Label>Országhívó:</Label>
            <SelectInput
              name="orszaghivo"
              id="orszaghivo"
              onChange={(e, v) => this.setOrszaghivo(v)}
              components={{ Option }}
              isSearchable={true}
              className="mb-1"
              classNames={{
                control: () => "select-input",
                menu: () => "select-input",
                singleValue: () => "select-input",
                placeholder: () => "select-input",
              }}
              placeholder="Keresés..."
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              options={orszagOptions}
              isClearable
            />
          </div>
          <div className="col-12 col-sm-3">
            <RFField
              label="Telefonszám:"
              tooltip={<CustomTooltip text={getTooltip('telefonszam')} id='telefonszamTT' className="mb-0" />}
              name="tel"
            />
          </div>
          <div className="col-md-6 row align-items-center">
            <div className="col-md-auto">
              {helyszinObj && helyszinObj.hirlevelUrl &&
                <div>
                  <a href={helyszinObj.hirlevelUrl} target='_blank'>Feliratkozás hirlevélre</a>
                </div>
              }
                <div>
                  <RFField
                    label={
                      <div style={{ paddingLeft: '20px' }}>
                        *Elolvastam és elfogadom az adatvédelmi nyilatkozatot.
                        <a target='adatvedelmi' href={helyszinObj && helyszinObj.adatvedelmiUrl} onClick={() => this.props.globals.route.navigate(this.props.globals.public_url.concat('/idopont/adatvedelmi'))}> Bővebben</a>
                      </div>
                  }
                    type="checkbox"
                    name="hozzajarulas"
                  />
                </div>
            </div>
            <div className="col-md-auto">
              <HCaptcha
                sitekey="15c55834-40b0-46f3-9893-1a2b4b32553d"
                onVerify={(token) => this.handleVerificationSuccess(token)}
                ref={this.captchaRef}
              />
            </div>
            <div className="col-md-12">
              <ProgressButton loading={this.state.sendButtonLoading}>
                Foglalás elküldése
              </ProgressButton>
            </div>
          </div>
        </div>
      </RFForm>
    </div>
  }

  render() {
    return <div className="container-fluid">
      {this.renderValasztok()}
      {this.renderIdopont()}
      {this.renderSzemelyes()}
    </div>;
  }
}
